import React from 'react';
import './IndustriesSection.css';

const INDUSTRIES = [
  { icon: '🏢', label: 'Offices & IT Parks' },
  { icon: '🏥', label: 'Hospitals & Clinics' },
  { icon: '🏘️', label: 'Residential Societies' },
  { icon: '🏭', label: 'Industrial Units' },
  { icon: '🏨', label: 'Hotels & Retail Spaces' },
  { icon: '🎪', label: 'Event Management' }
];

const RADIUS = 148;
const COUNT = INDUSTRIES.length;

function IndustriesSection() {
  return (
    <section className="industries-section industries-section--circle">
      <div className="industries-section-inner">
        <h2 className="industries-title">Industries We Serve</h2>
        <div className="industries-circle-wrap">
          <div className="industries-circle-rotating" aria-hidden="true">
            {INDUSTRIES.map((item, index) => {
              const angle = (360 / COUNT) * index;
              return (
                <div
                  key={index}
                  className="industry-card-outer"
                  style={{
                    transform: `rotate(${angle}deg) translateY(-${RADIUS}px) rotate(-${angle}deg)`
                  }}
                >
                  <div className="industry-card industry-card--circle">
                    <div className="industry-icon">{item.icon}</div>
                    <span className="industry-label">{item.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default IndustriesSection;
